/**
 * navigation/planGate.ts
 * Whether this org bought SK Upsell's WEBSITE.
 *
 * GET /v1/me carries `subscribed_products`: the product websites the org bought.
 * A plan can include Upsell only so it works underneath — the Upsell API keeps
 * serving that plan's own console, but the Upsell website is not theirs to
 * open. Such a user goes to the platform's not-in-plan page instead
 * (redirectToNotInPlan).
 *
 * Fails OPEN: a missing, null or malformed list means "no restriction". The
 * platform sends null while its PRODUCT_UI_GATE_ENABLED switch is off, for the
 * trial plan, and for Softknack staff. A wrong block locks a paying customer
 * out; a wrong allow does not.
 */

export const PRODUCT = 'upsell';

export function isNotInPlan(subscribedProducts: unknown, product: string = PRODUCT): boolean {
  if (!Array.isArray(subscribedProducts)) return false;
  return !subscribedProducts.includes(product);
}
